if($('.type-detail').length){
    $('a.chat span').text(askButton)
    $('.p-info-wrapper .add-to-cart-button').text(buyButton)
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart .quantity'))
    $('.customCart').append($('.social-buttons-wrapper .link-icons'))
    $('.customCart').append($('.add-to-cart button'))
    if($('.extended-description .detail-parameters tr th:contains("USP")').length){
        var uspWrapper = $('<div class="usp produkt"></div>');
        $('.detail-parameters th').each(function() {
            var thText = $(this).text().trim();
            if (thText.includes("USP")) {
                $('.usp.produkt').hide()
                $(this).closest('tr').hide()
                $('.p-info-wrapper .usp.produkt').remove();
                var uspText = $(this).closest('tr').find('td').html();
                var imageUrl = '/user/documents/upload/usp/'+$('meta[itemprop="productID"]').attr('content')+'/'+ thText.toLowerCase().replace(':', '')+'.svg?v='+new Date().getMinutes();
                var uspElement = `
                    <div class="usp-inner">
                        <div class="image">
                            <img src="${imageUrl}" alt="${thText}">
                        </div>
                        <p>${uspText}</p>
                    </div>`;
                uspWrapper.append(uspElement);
            }
        });
        $('.p-info-wrapper').append(uspWrapper);
    
    }
    else{
        if($('.benefitBanner .usp.produkt').length){
            $('.p-info-wrapper').append($('.benefitBanner .usp.produkt'))
        }
    }
    if($('.extended-description').length){
        $('.extended-description .detail-parameters tr th:contains("'+rowCategory+'")').closest('tr').hide()
        $('.p-detail-inner').append($('.extended-description'))
    }
   
    if($('.product-top .p-detail-info .flag-investice').length>0){
        $(document).ready(function() {
            $('.customCart').addClass('haveInvest').append('<div class="invest"><span class="investText">'+hodnotaBlizko+' <span class="investMoney"></span>.</span><input type="number" step="0.01"></div><div class="error-message"></div>');
            
            var price = parseFloat($('.p-final-price-wrapper .price-final').text().replace(/ /g, '').trim().replace(',', '.').replace('$', ''));
            var minimalAmount = parseFloat($('.p-info-wrapper .quantity .amount').attr('min'));
            var stepAmount = parseFloat($('.p-info-wrapper .quantity .amount').attr('min'));
            var decimals = parseInt($('.p-info-wrapper .quantity .amount').attr('data-decimals'));
            console.log(price)
            $('.investMoney').text(Number(price * minimalAmount).ShoptetFormatAsCurrency());
        
            function findNearestValidValue(value, price, stepAmount) {
                var nearestLower = ((value / price).toFixed(decimals)) * price;
                var nearestHigher = (parseFloat((value / price).toFixed(decimals)) + 0.001) * price;
                return {
                    lower: parseInt(nearestLower),
                    higher: parseInt(nearestHigher)
                };
            }
        
            let timeoutId;
        
            $('.invest input').on('input', function() {
                clearTimeout(timeoutId);
        
                timeoutId = setTimeout(() => {
                    const value = parseFloat($(this).val());
                    const errorMessageDiv = $('.customCart .error-message');
        
                    if (isNaN(value)) {
                        errorMessageDiv.text(platnaHodnota);
                        $('body').addClass('disabled-add-to-cart');
                        return;
                    }
        
                    if (value < price * minimalAmount) {
                        errorMessageDiv.text(hodnota+' ' + Number(price * minimalAmount).ShoptetFormatAsCurrency());
                        $('body').addClass('disabled-add-to-cart');
                    } else {
                        var nearestValues = findNearestValidValue(value, price, stepAmount);
                        var nearestLower = nearestValues.lower;
                        var nearestHigher = nearestValues.higher;
                        var unitPrize = (value / price).toFixed(decimals);
                        const tolerance = 0.01;
                        if (Math.abs(value - nearestLower) > tolerance && Math.abs(value - nearestHigher) > tolerance) {        
                            errorMessageDiv.text(nepresnaHodnota+' ' + nearestLower + ' or ' + nearestHigher + '.');
                            $('body').addClass('disabled-add-to-cart');
                        } else {
                            errorMessageDiv.text('');
                            $('body').removeClass('disabled-add-to-cart');
                            $('.p-info-wrapper .quantity input.amount').val(unitPrize);
                        }
                    }
                }, 500);
            });
        });
         
        
        
        
    
    }



}